// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KZx60","top":"styles_top__1fyrF"};